import React from 'react';
import Brands from '../components/Brands';
import Projects from '../components/Projects';
import Testimonial from '../components/Testimonial';
import Hero from '../components/Hero';
import About from '../components/About';
import Bio from '../components/Bio';
import Service from '../components/Service';
import Hobby from '../components/Hobby';
import HomePagdData from '../data/HomePagdData.json';
import Experience from '../components/Experience';
import Achievment from '../components/Achievment';
import Qualification from '../components/Qualification';
import Contact from '../components/Contact';
import BinaryScroll from '../components/BinaryScroll';

export default function Home() {
  const {
    hero,
    socialBtns,
    brands,
    about,
    bio,
    projects,
    service,
    qualification,
    hobby,
    experience,
    achievement,
    testimonial,
    contact,
  } = HomePagdData;
  return (
    <>
      <Hero data={hero} socialData={socialBtns} />
      <Brands data={brands} />
      <About data={about} />
      <Bio data={bio} />
      <BinaryScroll fromRight={true} />
      <Projects data={projects} />
      <Service data={service} />
      {/* <BinaryScroll fromRight={false} /> */}
      <Qualification data={qualification} />
      <Hobby data={hobby} />
      {/* <BinaryScroll fromRight={true} /> */}
      <Experience data={experience} />
      <Achievment data={achievement} />
      <Testimonial data={testimonial} />
      <Contact data={contact} socialData={socialBtns} />
    </>
  );
}
